// extracted by mini-css-extract-plugin
export var descriptionSection = "gamePage-module--descriptionSection--rwDlk";
export var downloadSection = "gamePage-module--downloadSection--Ucotn";
export var downloadLinkButton = "gamePage-module--downloadLinkButton--UU9Ju";